module.exports = __webpack_public_path__ + "img/feedback.1fed3c0e.png";